<ul class="UNFAPP-btch-wht-bxlst row">
  <li class="col-md-12 col-11">
    <div class="UNFAPP-btch-wht-box">
        <div class="img-box">
            <img [src]="batchData?.batchPicture" class="tcherimg" 
            (error)="_helper.profileImgError($event)"/>
        </div>
        <div class="UNFAPP-btch-info-area">
            <div class="lft-btch-info-area">
                <div class="btch-hdng-prt">
                    <!-- <h3 class="btch-hdng">{{batchData?.name}}</h3> -->
                    <div *ngIf="batchData?.name?.length>25; else donttruncate">
                        <h3 class="btch-hdng"><a title="{{batchData?.name}}">{{batchData?.name?.slice(0,25)+'...'}}</a></h3>
                    </div>
                    <ng-template #donttruncate>
                        <h3 class="btch-hdng">{{batchData?.name}}</h3>
                    </ng-template>
                    </div>
                <div class="btch-date-info-prt">
                    <div class="row">
                        <div class="col-md-4 col-6">
                            <div class="btch-date-bx">
                                <h3 class="btch-date-hdng">Starts</h3>
                                <h4 class="btch-date-data">{{batchData?.startDate | date}}</h4>
                            </div>
                        </div>
                        <div class="col-md-4 col-6">
                            <div class="btch-date-bx">
                                <h3 class="btch-date-hdng">Ends</h3>
                                <h4 class="btch-date-data">{{batchData?.endDate | date}}</h4>
                            </div>
                        </div>
                        <div class="col-md-4 col-6">
                            <div class="btch-date-bx">
                                <h3 class="btch-date-hdng">TIMINGS</h3>
                                <!-- <h4 class="btch-date-data">{{getStartTime(batchData?.startDate)}}</h4> -->

                                <h4 class="btch-date-data">{{batchData?.batchTimings}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="UNFAPP-btch-actnarea">
              <app-custom-button  type="button" [cta]="{name:'ENROLL NOW', type:'enroll', dataType:'batch', data:batchData}"></app-custom-button>
              <!-- <button class="btn btn-primary enrole-btn" (click)="openSession()">SCHEDULE</button> -->
            </div>
        </div>
    </div>
  </li>
</ul>
